/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/23/19
 * Time: 10:53 AM
 */
import React, { Component } from 'react';
import PlacesAutocomplete
  ,
{
  geocodeByAddress,
  getLatLng,
}
from 'react-places-autocomplete';
import './GoogleLocation.css'
class App extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = { location: '' };
  // }
  //
  // handleChange = location => {
  //   this.setState({ location });
  // };
  //
  // handleSelect = location => {
  //   console.log(location)
  //   geocodeByAddress(location)
  //     .then(results => getLatLng(results[0]))
  //     .then(latLng => console.log('Success', latLng))
  //     .catch(error => console.error('Error', error));
  // };
  //
  // addressHandler = (location) => {
  //   this.setState({ location });
  // };

  render() {
    return (
      <PlacesAutocomplete
        value={this.props.location}
        onChange={this.props.handleChange_}
        onSelect={this.props.handleSelect_}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
              {...getInputProps({
                placeholder: this.props.placeholder,
                id: 'location-search-input',
                className: 'location-search-input',
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div style={{padding:'1%',fontWeight:'600',border:'1px solid #e8e8e8'}}>Loading...</div>}
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer',padding:'1%',fontWeight:'600',border:'1px solid #e8e8e8' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer',padding:'1%',fontWeight:'600',border:'1px solid #e8e8e8' };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                    onClick={()=>this.props.addressHandler_(suggestion.description)}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}


export default App;
